import React, { Component } from 'react'
import { Routes, Route } from 'react-router'
import { Layout } from './pages/Layout'
import PaymentWrapper from './pages/Payment'
import DebtCollectionPaymentWrapper from "./pages/DebtCollectionPayment"


import './custom.css'

export default class App extends Component {
  render() {
    return (
      <Layout>
        <Routes>
          <Route path='/:partnerName/:paymentLinkGuid' element={<PaymentWrapper />} />
          <Route path='/easylink/:partnerName/:paymentLinkGuid' element={<DebtCollectionPaymentWrapper />} />
        </Routes>
      </Layout>
    )
  }
}